import { createEntityAdapter, createSelector } from '@reduxjs/toolkit';

const shadowProjectsAdapter = createEntityAdapter();
const shadowRecordsAdapter = createEntityAdapter();

const selectShadowDataState = (state) => state.shadowData;

const selectShadowProjectsEntityState = createSelector(
  [selectShadowDataState],
  (state) => state.shadowProjects
);

export const {
  selectAll: selectAllShadowProjects,
  selectById: selectShadowProjectById,
  selectEntities: selectShadowProjectEntities,
} = shadowProjectsAdapter.getSelectors(selectShadowProjectsEntityState);

export const selectIsLoadingShadowProject = createSelector(
  [selectShadowDataState],
  (state) => state.isLoadingShadowProject
);

export const selectShadowProjectForProject = (projectId, businessId) =>
  createSelector([selectShadowProjectEntities], (entities) => {
    if (!projectId || !businessId) return undefined;
    const shadowProjectId = `${projectId}_${businessId}`;
    return entities[shadowProjectId];
  });

const selectShadowRecordsEntityState = createSelector(
  [selectShadowDataState],
  (state) => state.shadowRecords
);

export const {
  selectAll: selectAllShadowRecords,
  selectById: selectShadowRecordById,
  selectEntities: selectShadowRecordEntities,
} = shadowRecordsAdapter.getSelectors(selectShadowRecordsEntityState);

export const selectIsLoadingShadowRecords = createSelector(
  [selectShadowDataState],
  (state) => state.isLoadingShadowRecords
);

export const selectIsUpdatingShadowRecord = createSelector(
  [selectShadowDataState],
  (state) => state.isUpdatingShadowRecord
);

export const selectShadowRecordForRecord = (recordId, businessId) =>
  createSelector([selectShadowRecordEntities], (entities) => {
    if (!recordId || !businessId) return undefined;
    const shadowRecordId = `${recordId}_${businessId}`;
    return entities[shadowRecordId];
  });
